var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.orders
        ? _c(
            "div",
            [
              _c("div", { staticClass: "card mb-3 back-white" }, [
                _c(
                  "div",
                  { staticClass: "card-body flex justify-content-between" },
                  [
                    _c("span", [
                      _vm._v("Всего заявок: "),
                      _c("strong", [_vm._v(_vm._s(_vm.orders.length))]),
                      _vm._v(" ("),
                      _c("strong", [_vm._v(_vm._s(_vm.ordersSum))]),
                      _vm._v(")"),
                    ]),
                    _vm._v(" "),
                    _vm.dialogs && _vm.dialogs.length
                      ? _c("span", [
                          _vm._v("Запросов: "),
                          _c("strong", [_vm._v(_vm._s(_vm.dialogs.length))]),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.orders, function (order) {
                return _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("OrderDetails", {
                        attrs: {
                          order: order,
                          smsPayment:
                            _vm.smsToOrders && _vm.smsToOrders[order.id],
                          refreshOrder: (silent) => _vm.getOrders(silent),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-footer" }, [
                    _vm.actions[order.id].rejectOrderOpen
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "input-group mb-3" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.actions[order.id].rejectComment,
                                    expression:
                                      "actions[order.id].rejectComment",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Причина отказа",
                                },
                                domProps: {
                                  value: _vm.actions[order.id].rejectComment,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.actions[order.id],
                                      "rejectComment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "В отказ",
                                  className: "btn btn-outline-danger",
                                  loading: _vm.actions[order.id].loading,
                                  onClick: () =>
                                    _vm.updateOrder(order.id, "reject_order"),
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.actions[order.id].orderCorrectionOpen
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "input-group mb-3" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.actions[order.id].correction,
                                    expression: "actions[order.id].correction",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Данные для коррекции",
                                },
                                domProps: {
                                  value: _vm.actions[order.id].correction,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.actions[order.id],
                                      "correction",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Отправить",
                                  color: "#5BBFDE",
                                  className: "btn btn-outline-success",
                                  loading: _vm.actions[order.id].loading,
                                  onClick: () =>
                                    _vm.updateOrder(
                                      order.id,
                                      "send_correction"
                                    ),
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.actions[order.id].orderShift
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "input-group mb-3" },
                            [
                              _c("DateSelectProps", {
                                ref: "dateSelect",
                                refInFor: true,
                                attrs: {
                                  disabled: true,
                                  useDisabledDates:
                                    _vm.actions[order.id].shiftDate,
                                  customShortCutsDates: false,
                                  onSelect: (date, formated) =>
                                    (_vm.actions[order.id].shiftDate =
                                      formated),
                                  selectedDate: _vm.actions[order.id].shiftDate,
                                },
                              }),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Перенести",
                                  color: "#5BBFDE",
                                  className: "btn btn-outline-success",
                                  loading: _vm.actions[order.id].loading,
                                  onClick: () =>
                                    _vm.updateOrder(order.id, "shift_order"),
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.actions[order.id].orderQuestionOpen
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "input-group mb-3" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.actions[order.id].comment,
                                    expression: "actions[order.id].comment",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Вопрос менеджеру",
                                },
                                domProps: {
                                  value: _vm.actions[order.id].comment,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.actions[order.id],
                                      "comment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Отправить",
                                  color: "#5BBFDE",
                                  className: "btn btn-outline-success",
                                  loading: _vm.actions[order.id].loading,
                                  onClick: () =>
                                    _vm.updateOrder(order.id, "send_question"),
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.actions[order.id].orderCommentOpen
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "input-group mb-3" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.actions[order.id].comment,
                                    expression: "actions[order.id].comment",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Ваш комментарий",
                                },
                                domProps: {
                                  value: _vm.actions[order.id].comment,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.actions[order.id],
                                      "comment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Сохранить",
                                  color: "#5BBFDE",
                                  className: "btn btn-outline-success",
                                  loading: _vm.actions[order.id].loading,
                                  onClick: () =>
                                    _vm.updateOrder(order.id, "add_comment"),
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.actions[order.id].orderLineActionsOpen
                      ? _c(
                          "div",
                          { staticClass: "mb-3 line_btns_block" },
                          [
                            _c("LoadingButton", {
                              attrs: {
                                title:
                                  '<i class="icon-fa icon-fa-backward rotate-up"></i> Первая',
                                color: "#5BBFDE",
                                loading: _vm.actions[order.id].loading,
                                onClick: () =>
                                  _vm.updateOrder(
                                    order.id,
                                    "change_line",
                                    "first"
                                  ),
                                className: "btn btn-default",
                              },
                            }),
                            _vm._v(" "),
                            _c("LoadingButton", {
                              attrs: {
                                title:
                                  '<i class="icon-fa icon-fa-arrow-circle-up"></i>',
                                loading: _vm.actions[order.id].loading,
                                color: "#5BBFDE",
                                onClick: () =>
                                  _vm.updateOrder(
                                    order.id,
                                    "change_line",
                                    "up"
                                  ),
                                className: "btn btn-default",
                              },
                            }),
                            _vm._v(" "),
                            _c("LoadingButton", {
                              attrs: {
                                title:
                                  '<i class="icon-fa icon-fa-arrow-circle-down"></i>',
                                color: "#5BBFDE",
                                loading: _vm.actions[order.id].loading,
                                onClick: () =>
                                  _vm.updateOrder(
                                    order.id,
                                    "change_line",
                                    "down"
                                  ),
                                className: "btn btn-default",
                              },
                            }),
                            _vm._v(" "),
                            _c("LoadingButton", {
                              attrs: {
                                title:
                                  '<i class="icon-fa icon-fa-backward rotate-down"></i> Последняя',
                                color: "#5BBFDE",
                                loading: _vm.actions[order.id].loading,
                                onClick: () =>
                                  _vm.updateOrder(
                                    order.id,
                                    "change_line",
                                    "last"
                                  ),
                                className: "btn btn-default",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex justify-content-between" }, [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "dropdown-menu",
                            {
                              staticClass: "menu",
                              attrs: { "menu-title": "", "dark-mode": "auto" },
                            },
                            [
                              _c(
                                "section",
                                {
                                  staticClass: "option",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDialog(
                                        order.id,
                                        "orderLineActionsOpen"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("button", [
                                    _c("strong", [_vm._v("Изменить очередь")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v("меняет очередность заявок"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "section",
                                {
                                  staticClass: "option",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDialog(
                                        order.id,
                                        "orderCorrectionOpen"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("button", [
                                    _c("strong", [_vm._v("Коррекция")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v("изменения кол. смена адреса и тд"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "section",
                                {
                                  staticClass: "option",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDialog(
                                        order.id,
                                        "orderQuestionOpen"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("button", [
                                    _c("strong", [_vm._v("Вопрос менеджеру")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v("новая заявка, стоимость и тд"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "section",
                                {
                                  staticClass: "option",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDialog(
                                        order.id,
                                        "orderShift"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("button", [
                                    _c("strong", [_vm._v("Перенос")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v("перенос на другую дату"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "section",
                                {
                                  staticClass: "option",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateOrder(
                                        order.id,
                                        "no_reply"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("button", [
                                    _c("strong", [_vm._v("Недозвон")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v(
                                      'станет последней в очереди с пометкой "недозвон"'
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "section",
                                {
                                  staticClass: "option",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDialog(
                                        order.id,
                                        "rejectOrderOpen"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("button", [
                                    _c("strong", [_vm._v("Отказ")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v("отмена заказчиком"),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-success ml-2",
                              on: {
                                click: function ($event) {
                                  return _vm.openDialog(
                                    order.id,
                                    "orderCommentOpen"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Комментарий\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-info",
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("TabletOrder", {
                                  orderId: order.id,
                                })
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  +order.pay_method !== 3 &&
                                    order.credit_card_id
                                    ? "Взять наличные и отменить предоплату"
                                    : "Доставить"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }